import './ConnectionFieldValue.css';

const FieldValue = ({ value }: { value: string | undefined }) => {
    return <div title={value ?? ''} className="connection-field-value">{value ?? 'Not selected'}</div>
}

export default FieldValue; 